/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления точками продаж.
 * Точки проджаж используются как точки дистрибьюции ключей
 */

/**
 * Сервис точек продаж
 */
export class SalepointServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения точки продаж.
   * Поддерживает создание и обновление.
   * Метод доступен для: manager, service, application(ad:edit)
   */
  PostSalepoint = (req: PostSalepointRequestDto, init?: RequestInit): Promise<PostSalepointResponseDto> => {
    return fm.request<PostSalepointRequestDto, PostSalepointResponseDto>(`${this.host}/ad/api/v1/salepoint`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения точки продаж.
   * Не требует авторизации
   */
  GetSalepoint = (req: GetSalepointRequestDto, init?: RequestInit): Promise<GetSalepointResponseDto> => {
    return fm.request<GetSalepointRequestDto, GetSalepointResponseDto>(`${this.host}/ad/api/v1/salepoint/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка точек продаж.
   * Не требует авторизации
   */
  GetSalepointList = (req?: GetSalepointListRequestDto, init?: RequestInit): Promise<GetSalepointListResponseDto[]> => {
    return fm.list<GetSalepointListRequestDto, GetSalepointListResponseDto>(`${this.host}/ad/api/v1/salepoint/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества точек продаж.
   * Не требует авторизации
   */
  GetSalepointCount = (req?: GetSalepointCountRequestDto, init?: RequestInit): Promise<GetSalepointCountResponseDto> => {
    return fm.request<GetSalepointCountRequestDto, GetSalepointCountResponseDto>(`${this.host}/ad/api/v1/salepoint/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов точек продаж
 */
export enum SalepointType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Теле2
   */
  TELE2 = "TELE2",
  /**
   * Почта россии
   */
  POCHTA_ROSSII = "POCHTA_ROSSII",
  /**
   * Перекресток
   */
  PEREKRESTOK = "PEREKRESTOK",
  /**
   * Пятерочка
   */
  PYATEROCHKA = "PYATEROCHKA",
  /**
   * Другая
   */
  ANOTHER = "ANOTHER",
  /**
   * Мегафон
   */
  MEGAFON = "MEGAFON",
}
/**
 * Справочник типов точек продаж
 */
export type SalepointTypeResponseEnum = keyof typeof SalepointType
/**
 * Справочник типов точек продаж
 */
export type SalepointTypeRequestEnum = Exclude<SalepointTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник дней
 */
export enum SalepointWorktimeDayType {
  /**
   * Значение не указано
   */
  DAY_TYPE_UNKNOWN = "DAY_TYPE_UNKNOWN",
  /**
   * Понедельник
   */
  MONDAY = "MONDAY",
  /**
   * Вторник
   */
  TUESDAY = "TUESDAY",
  /**
   * Среда
   */
  WEDNESDAY = "WEDNESDAY",
  /**
   * Четверг
   */
  THURSDAY = "THURSDAY",
  /**
   * Пятница
   */
  FRIDAY = "FRIDAY",
  /**
   * Суббота
   */
  SATURDAY = "SATURDAY",
  /**
   * Воскресенье
   */
  SUNDAY = "SUNDAY",
}
/**
 * Справочник дней
 */
export type SalepointWorktimeDayTypeResponseEnum = keyof typeof SalepointWorktimeDayType
/**
 * Справочник дней
 */
export type SalepointWorktimeDayTypeRequestEnum = Exclude<SalepointWorktimeDayTypeResponseEnum, "DAY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum SalepointPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type SalepointPagingDirectionTypeResponseEnum = keyof typeof SalepointPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type SalepointPagingDirectionTypeRequestEnum = Exclude<SalepointPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum SalepointPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По дистанции
   */
  DISTANCE = "DISTANCE",
  /**
   * По рангу близости.
   * При поиске по тексту
   */
  RANK_CD = "RANK_CD",
}
/**
 * Справочник типов значений сортировки
 */
export type SalepointPagingOrderByTypeResponseEnum = keyof typeof SalepointPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type SalepointPagingOrderByTypeRequestEnum = Exclude<SalepointPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества точек продаж
 */
export type GetSalepointCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: SalepointFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества точек продаж
 */
export type GetSalepointCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего точек продаж
   */
  readonly data: number
}>
/**
 * Запрос получения списка точек продаж
 */
export type GetSalepointListRequestDto = {
  /**
   * Фильтр
   */
  filter?: SalepointFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: SalepointPagingRequestDto
}>
/**
 * Ответ на запрос получения списка точек продаж
 */
export type GetSalepointListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка продаж
   */
  readonly data: SalepointResponseDto
}>
/**
 * Запрос получения точки продаж
 */
export type GetSalepointRequestDto = {
  /**
   * Идентификатор точки продаж
   */
  id: number
}
/**
 * Ответ на запрос получения точки продаж
 */
export type GetSalepointResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка продаж
   */
  readonly data: SalepointResponseDto
}>
/**
 * Запрос сохранения точки продаж
 */
export type PostSalepointRequestDto = {
  /**
   * Точка продаж
   */
  data: SalepointRequestDto
}
/**
 * Ответ на запрос сохранения точки продаж
 */
export type PostSalepointResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка продаж
   */
  readonly data: SalepointResponseDto
}>
/**
 * Точка продаж
 */
export type SalepointRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Название
   */
  title: string
  /**
   * Тип точки продаж
   */
  type: SalepointTypeRequestEnum
  /**
   * Описание
   */
  description?: string | null
  /**
   * Адрес
   */
  address: string
  /**
   * Местонахождение
   */
  location: SalepointLocationRequestDto
  /**
   * Рабочее время
   */
  worktimes: SalepointWorktimeRequestDto[]
  /**
   * Номер телефона
   */
  phoneNumber?: string | null
  /**
   * Ссылка на сайт
   */
  siteUrl: string
  /**
   * Дата архивации
   */
  archievedAt?: string | null
}
/**
 * Точка продаж
 */
export type SalepointResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Название
   */
  title: string
  /**
   * Тип точки продаж
   */
  type: SalepointTypeResponseEnum
  /**
   * Описание
   */
  description: string | null
  /**
   * Адрес
   */
  address: string
  /**
   * Местонахождение
   */
  location: SalepointLocationResponseDto
  /**
   * Рабочее время
   */
  worktimes: SalepointWorktimeResponseDto[]
  /**
   * Номер телефона
   */
  phoneNumber: string | null
  /**
   * Ссылка на сайт
   */
  siteUrl: string
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Дата архивации
   */
  archievedAt: string | null
}
/**
 * Местонахождение
 */
export type SalepointLocationRequestDto = {
  /**
   * Широта
   */
  latitude: number
  /**
   * Долгота
   */
  longitude: number
}
/**
 * Местонахождение
 */
export type SalepointLocationResponseDto = {
  /**
   * Широта
   */
  latitude: number
  /**
   * Долгота
   */
  longitude: number
}
/**
 * Рабочее время
 */
export type SalepointWorktimeRequestDto = {
  /**
   * День недели
   */
  dayType: SalepointWorktimeDayTypeRequestEnum
  /**
   * Время открытия
   */
  openedAt: string
  /**
   * Время закрытия
   */
  closedAt: string
}
/**
 * Рабочее время
 */
export type SalepointWorktimeResponseDto = {
  /**
   * День недели
   */
  dayType: SalepointWorktimeDayTypeResponseEnum
  /**
   * Время открытия
   */
  openedAt: string
  /**
   * Время закрытия
   */
  closedAt: string
}
/**
 * Фильтр точек продаж
 */
export type SalepointFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Поиск производится по полям:
   * # - Название
   */
  text?: string | null
  /**
   * По местонахождению.
   * Игнорируется если дистанция не передана
   */
  location?: SalepointFilterLocationRequestDto | null
  /**
   * По дистанции.
   * Игнорируется если местонахождение не передано
   */
  distance?: number | null
  /**
   * По архивированым
   */
  isArchieved?: boolean | null
}
/**
 * Фильтр точек продаж
 */
export type SalepointFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Поиск производится по полям:
   * # - Название
   */
  text: string | null
  /**
   * По местонахождению.
   * Игнорируется если дистанция не передана
   */
  location: SalepointFilterLocationResponseDto | null
  /**
   * По дистанции.
   * Игнорируется если местонахождение не передано
   */
  distance: number | null
  /**
   * По архивированым
   */
  isArchieved: boolean | null
}
/**
 * Местонахождение
 */
export type SalepointFilterLocationRequestDto = {
  /**
   * По широте
   */
  latitude?: number
  /**
   * По долготе
   */
  longitude?: number
}
/**
 * Местонахождение
 */
export type SalepointFilterLocationResponseDto = {
  /**
   * По широте
   */
  latitude: number
  /**
   * По долготе
   */
  longitude: number
}
/**
 * Пагинация по точекам продаж
 */
export type SalepointPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ORDER_BY_TYPE_ID
   */
  orderByType?: SalepointPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: SalepointPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация по точекам продаж
 */
export type SalepointPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ORDER_BY_TYPE_ID
   */
  orderByType: SalepointPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: SalepointPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества точек продаж
   */
  "GetSalepointCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества точек продаж",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SalepointFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества точек продаж
   */
  "GetSalepointCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества точек продаж",
    "fields": {
      /**
       * Всего точек продаж
       */
      "data": {
        "type": "int32",
        "text": "Всего точек продаж",
      },
    },
  },
  /**
   * Запрос получения списка точек продаж
   */
  "GetSalepointListRequest": {
    "kind": "class",
    "text": "Запрос получения списка точек продаж",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SalepointFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "SalepointPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка точек продаж
   */
  "GetSalepointListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка точек продаж",
    "fields": {
      /**
       * Точка продаж
       */
      "data": {
        "type": "Salepoint",
        "text": "Точка продаж",
      },
    },
  },
  /**
   * Запрос получения точки продаж
   */
  "GetSalepointRequest": {
    "kind": "class",
    "text": "Запрос получения точки продаж",
    "fields": {
      /**
       * Идентификатор точки продаж
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор точки продаж",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения точки продаж
   */
  "GetSalepointResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения точки продаж",
    "fields": {
      /**
       * Точка продаж
       */
      "data": {
        "type": "Salepoint",
        "text": "Точка продаж",
      },
    },
  },
  /**
   * Запрос сохранения точки продаж
   */
  "PostSalepointRequest": {
    "kind": "class",
    "text": "Запрос сохранения точки продаж",
    "fields": {
      /**
       * Точка продаж
       */
      "data": {
        "type": "Salepoint",
        "text": "Точка продаж",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения точки продаж
   */
  "PostSalepointResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения точки продаж",
    "fields": {
      /**
       * Точка продаж
       */
      "data": {
        "type": "Salepoint",
        "text": "Точка продаж",
      },
    },
  },
  /**
   * Точка продаж
   */
  "Salepoint": {
    "kind": "class",
    "text": "Точка продаж",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Название
       */
      "title": {
        "type": "string",
        "text": "Название",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип точки продаж
       */
      "type": {
        "type": "Salepoint.Type",
        "text": "Тип точки продаж",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Описание
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание",
      },
      /**
       * Адрес
       */
      "address": {
        "type": "string",
        "text": "Адрес",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Местонахождение
       */
      "location": {
        "type": "Salepoint.Location",
        "text": "Местонахождение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Рабочее время
       */
      "worktimes": {
        "type": "Salepoint.Worktime",
        "text": "Рабочее время",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер телефона
       */
      "phoneNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер телефона",
      },
      /**
       * Ссылка на сайт
       */
      "siteUrl": {
        "type": "string",
        "text": "Ссылка на сайт",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Дата архивации
       */
      "archievedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата архивации",
      },
    },
  },
  /**
   * Местонахождение
   */
  "Salepoint.Location": {
    "kind": "class",
    "text": "Местонахождение",
    "fields": {
      /**
       * Широта
       */
      "latitude": {
        "type": "float",
        "text": "Широта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Долгота
       */
      "longitude": {
        "type": "float",
        "text": "Долгота",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Рабочее время
   */
  "Salepoint.Worktime": {
    "kind": "class",
    "text": "Рабочее время",
    "fields": {
      /**
       * День недели
       */
      "dayType": {
        "type": "Salepoint.Worktime.DayType",
        "text": "День недели",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Время открытия
       */
      "openedAt": {
        "type": "string",
        "text": "Время открытия",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Время закрытия
       */
      "closedAt": {
        "type": "string",
        "text": "Время закрытия",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр точек продаж
   */
  "SalepointFilter": {
    "kind": "class",
    "text": "Фильтр точек продаж",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Поиск производится по полям:
       * # - Название
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Поиск производится по полям:\n# - Название",
      },
      /**
       * По местонахождению.
       * Игнорируется если дистанция не передана
       */
      "location": {
        "type": "SalepointFilter.Location",
        "text": "По местонахождению.\nИгнорируется если дистанция не передана",
      },
      /**
       * По дистанции.
       * Игнорируется если местонахождение не передано
       */
      "distance": {
        "type": "google.protobuf.FloatValue",
        "text": "По дистанции.\nИгнорируется если местонахождение не передано",
      },
      /**
       * По архивированым
       */
      "isArchieved": {
        "type": "google.protobuf.BoolValue",
        "text": "По архивированым",
      },
    },
  },
  /**
   * Местонахождение
   */
  "SalepointFilter.Location": {
    "kind": "class",
    "text": "Местонахождение",
    "fields": {
      /**
       * По широте
       */
      "latitude": {
        "type": "float",
        "text": "По широте",
      },
      /**
       * По долготе
       */
      "longitude": {
        "type": "float",
        "text": "По долготе",
      },
    },
  },
  /**
   * Пагинация по точекам продаж
   */
  "SalepointPaging": {
    "kind": "class",
    "text": "Пагинация по точекам продаж",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ORDER_BY_TYPE_ID
       */
      "orderByType": {
        "type": "SalepointPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ORDER_BY_TYPE_ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "SalepointPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Справочник типов точек продаж
   */
  "Salepoint.Type": {
    "kind": "enum",
    "text": "Справочник типов точек продаж",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Теле2
       */
      "TELE2": {
        "i": 1,
        "text": "Теле2",
      },
      /**
       * Почта россии
       */
      "POCHTA_ROSSII": {
        "i": 2,
        "text": "Почта россии",
      },
      /**
       * Перекресток
       */
      "PEREKRESTOK": {
        "i": 3,
        "text": "Перекресток",
      },
      /**
       * Пятерочка
       */
      "PYATEROCHKA": {
        "i": 4,
        "text": "Пятерочка",
      },
      /**
       * Другая
       */
      "ANOTHER": {
        "i": 5,
        "text": "Другая",
      },
      /**
       * Мегафон
       */
      "MEGAFON": {
        "i": 6,
        "text": "Мегафон",
      },
    },
  },
  /**
   * Справочник дней
   */
  "Salepoint.Worktime.DayType": {
    "kind": "enum",
    "text": "Справочник дней",
    "values": {
      /**
       * Значение не указано
       */
      "DAY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Понедельник
       */
      "MONDAY": {
        "i": 1,
        "text": "Понедельник",
      },
      /**
       * Вторник
       */
      "TUESDAY": {
        "i": 2,
        "text": "Вторник",
      },
      /**
       * Среда
       */
      "WEDNESDAY": {
        "i": 3,
        "text": "Среда",
      },
      /**
       * Четверг
       */
      "THURSDAY": {
        "i": 4,
        "text": "Четверг",
      },
      /**
       * Пятница
       */
      "FRIDAY": {
        "i": 5,
        "text": "Пятница",
      },
      /**
       * Суббота
       */
      "SATURDAY": {
        "i": 6,
        "text": "Суббота",
      },
      /**
       * Воскресенье
       */
      "SUNDAY": {
        "i": 7,
        "text": "Воскресенье",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "SalepointPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "SalepointPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По дистанции
       */
      "DISTANCE": {
        "i": 2,
        "text": "По дистанции",
      },
      /**
       * По рангу близости.
       * При поиске по тексту
       */
      "RANK_CD": {
        "i": 3,
        "text": "По рангу близости.\nПри поиске по тексту",
      },
    },
  },
}